import { render, staticRenderFns } from "./suggestions.vue.js?vue&type=template&id=3928ec6a!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./suggestions.vue?vue&type=template&id=3928ec6a"
import script from "./suggestions.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./suggestions.vue?vue&type=script&lang=js"
export * from "./suggestions.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./suggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports